<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-3" />

    <v-alert v-if="!cargando && items.length === 0" type="info" dense text>
      No se encontraron listas de precio.
    </v-alert>

    <v-card v-for="(item, idx) in items" :key="idx" outlined class="mb-4">
      <v-card-title class="py-2 px-4 grey lighten-4 d-flex align-center">
        <v-icon small color="primary" class="mr-2">mdi-format-list-bulleted-type</v-icon>
        <span class="text-subtitle-2 font-weight-bold">{{ item.tipoListaPrecio.nombre }}</span>
        <v-chip small color="primary" dark class="ml-3">{{ item.categoriaUniversidad.nombre }}</v-chip>
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-0">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr class="grey lighten-4">
                <th>Área</th>
                <th>Modalidad Programa</th>
                <th>Modalidad Pago</th>
                <th>Concepto</th>
                <th class="text-right">Monto Cuota / Módulo</th>
                <th class="text-right">N° Cuotas / Módulos</th>
                <th class="text-right">Monto</th>
                <th class="text-right">Total Monto</th>
                <th class="text-right">% Desc.</th>
                <th class="text-right">Precio Mín.</th>
                <th class="text-right">Total Precio Mín.</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(area, aIdx) in item.areas">
                <template v-for="(mod, mIdx) in ordenarModalidades(area.modalidades)">
                  <tr v-for="(con, cIdx) in mod.conceptos" :key="`${aIdx}-${mIdx}-${cIdx}`">
                    <td v-if="mIdx === 0 && cIdx === 0" :rowspan="contarFilasArea(area)" class="font-weight-medium">
                      {{ area.areaUniversidad.nombre }}
                    </td>
                    <td v-if="mIdx === 0 && cIdx === 0" :rowspan="contarFilasArea(area)">
                      <v-chip x-small label outlined>{{
                        modalidadesProgramasUniversidadesLabels[area.modalidad]
                      }}</v-chip>
                    </td>
                    <td v-if="cIdx === 0" :rowspan="mod.conceptos.length">
                      <v-chip
                        x-small
                        label
                        :color="mod.modalidadPago === 'credito' ? 'blue lighten-4' : 'green lighten-4'"
                        :text-color="mod.modalidadPago === 'credito' ? 'blue darken-2' : 'green darken-2'">
                        {{ mod.modalidadPago.toUpperCase() }}
                      </v-chip>
                    </td>
                    <td>{{ con.conceptoPago.nombre }}</td>
                    <td class="text-right">
                      {{ con.numeroCuotas > 0 ? Math.round((con.monto / con.numeroCuotas) * 100) / 100 : 0 }}
                    </td>
                    <td class="text-right">{{ con.numeroCuotas }}</td>
                    <td class="text-right font-weight-medium">{{ con.monto }}</td>
                    <td
                      v-if="cIdx === 0"
                      :rowspan="mod.conceptos.length"
                      class="text-right font-weight-bold"
                      :class="
                        mod.modalidadPago === 'credito' ? 'blue--text text--darken-2' : 'green--text text--darken-2'
                      ">
                      {{ sumarMonto(mod.conceptos) }}
                    </td>
                    <td class="text-right">
                      <v-chip
                        x-small
                        label
                        :color="con.porcentajeMaximoDescuento > 0 ? 'orange lighten-4' : 'grey lighten-3'">
                        {{ con.porcentajeMaximoDescuento }}%
                      </v-chip>
                    </td>
                    <td
                      class="text-right font-weight-bold"
                      :class="
                        mod.modalidadPago === 'credito' ? 'blue--text text--darken-2' : 'green--text text--darken-2'
                      ">
                      {{ con.precioTotalMinimo }}
                    </td>
                    <td
                      v-if="cIdx === 0"
                      :rowspan="mod.conceptos.length"
                      class="text-right font-weight-bold"
                      :class="
                        mod.modalidadPago === 'credito' ? 'blue--text text--darken-2' : 'green--text text--darken-2'
                      ">
                      {{ sumarPrecioMinimo(mod.conceptos) }}
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ModalidadesProgramasUniversidadesLabels } from '../../utils/constantes';

export default {
  name: 'TablaListaPrecio',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalidadesProgramasUniversidadesLabels: ModalidadesProgramasUniversidadesLabels,
    };
  },
  methods: {
    ordenarModalidades(modalidades) {
      const orden = { contado: 0, credito: 1 };
      return [...modalidades].sort((a, b) => (orden[a.modalidadPago] ?? 2) - (orden[b.modalidadPago] ?? 2));
    },
    contarFilasArea(area) {
      return area.modalidades.reduce((sum, mod) => sum + mod.conceptos.length, 0);
    },
    sumarMonto(conceptos) {
      return Math.round(conceptos.reduce((sum, con) => sum + Number(con.monto), 0) * 100) / 100;
    },
    sumarPrecioMinimo(conceptos) {
      return Math.round(conceptos.reduce((sum, con) => sum + Number(con.precioTotalMinimo), 0) * 100) / 100;
    },
  },
};
</script>
